import {Item, ItemContent, ItemDescription, ItemTitle} from "@/components/ui/item";

import {getHouseholdResidentDisplayName} from "../lib/household-membership";
import {formatHouseholdComboboxDescription} from "../lib/household-combobox-display";
import type {Household} from "../types";

export function HouseholdComboboxItem({household}: {household: Household}) {
  const assigneeName = getHouseholdResidentDisplayName(household);
  const residentLabel = assigneeName !== "—" ? assigneeName : null;

  return (
    <Item size="sm" className="p-0">
      <ItemContent>
        <ItemTitle>
          {household.name}
          {residentLabel ? (
            <span className="text-muted-foreground font-normal"> · {residentLabel}</span>
          ) : null}
        </ItemTitle>
        <ItemDescription className="line-clamp-none text-xs whitespace-normal break-words">
          {formatHouseholdComboboxDescription(household)}
        </ItemDescription>
      </ItemContent>
    </Item>
  );
}
